var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6211 2.12109V17.1211C18.6211 17.5189 18.4631 17.9004 18.1818 18.1818C17.9004 18.4631 17.5189 18.6211 17.1211 18.6211H2.12109C1.72327 18.6211 1.34174 18.4631 1.06043 18.1818C0.779129 17.9004 0.621094 17.5189 0.621094 17.1211V2.12109C0.621094 1.72327 0.779129 1.34174 1.06043 1.06043C1.34174 0.779129 1.72327 0.621094 2.12109 0.621094H17.1211C17.5189 0.621094 17.9004 0.779129 18.1818 1.06043C18.4631 1.34174 18.6211 1.72327 18.6211 2.12109ZM17.1211 17.1211V2.12109H2.12109V17.1211H17.1211Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCheckbox);
export default __webpack_public_path__ + "static/media/blank_checkbox.e25f2a40a9cc37d7b8e53cb440bcc589.svg";
export { ForwardRef as ReactComponent };